var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { customElement, property } from 'lit/decorators.js';
import { QboFetch } from '@quandis/qbo4.ui/src/qbo/qbo-fetch.js';
/**
  * Renders a <select> element with options populated from a JSON array.
  *
  * @remarks
  * This element is a thin wrapper around {@link QboFetch} that renders a <select> element with options populated from a JSON array.
  */
let QboBadge = class QboBadge extends QboFetch {
    constructor() {
        super(...arguments);
        this.loading = false;
        /**
         * @description A CSS selector that identifies the parent element containing the badges.
         */
        this.target = null;
        this.values = [];
        this.targetElement = null;
        /**
         * @description A CSS selector that identifies where to render the badge elements.
         * These elements should have a data-badge attribute that contributes to the API call.
         * @example <div data-badge="123"/>
         */
        this.selector = '*[data-badge]';
    }
    async connectedCallback() {
        this.targetElement = (this.target != null) ? this.closest(this.target) : this;
        if (this.targetElement == null) {
            console.error(`Could not find target element ${this.target}`);
            return;
        }
        this.targetElement.addEventListener('qbo-updated', this.getIds.bind(this));
        super.connectedCallback();
    }
    disconnectedCallback() {
        this.targetElement?.removeEventListener('qbo-updated', this.getIds);
    }
    getPayload(headers) {
        const payload = super.getPayload(headers) ?? {};
        payload["idList"] = this.values.join(",");
    }
    ;
    getIds() {
        console.log('reacting to target qbo-updated');
        if (this.targetElement == null)
            return;
        const values = [];
        const elements = this.targetElement.querySelectorAll(this.selector);
        elements.forEach((element) => {
            const dataBadgeValue = element.getAttribute('data-badge');
            if (dataBadgeValue !== null) {
                values.push(dataBadgeValue);
            }
        });
        this.values = values;
    }
    async fetchData(headers, payload) {
        super.fetchData(headers, payload);
    }
    render() {
        const elements = this.targetElement.querySelectorAll(this.selector);
        elements.forEach((element) => {
            element.innerHTML = element.getAttribute('data-badge') ?? '';
        });
    }
};
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboBadge.prototype, "loading", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboBadge.prototype, "target", void 0);
__decorate([
    property(),
    __metadata("design:type", Array)
], QboBadge.prototype, "values", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboBadge.prototype, "selector", void 0);
QboBadge = __decorate([
    customElement('qbo-badge')
], QboBadge);
export { QboBadge };
